import canOpenDocument from "utils/document/can_open_document";

export default function getDocumentPathName(
  organisationId,
  projectId,
  user,
  document,
  canOpenWhileProcessingIssues,
  canChatImmediately,
  needsToSeeDocumentText,
) {
  if (document.status && document.status !== "OK") {
    return "";
  }
  const commonPathName = `/organisation/${organisationId}/project/${projectId}/document`;
  const isAdmin = user.is_admin;
  const canOpenDoc = canOpenDocument(
    document.concat_load_state ?? [],
    document.concat_parse_state ?? [],
    canOpenWhileProcessingIssues,
    canChatImmediately,
    needsToSeeDocumentText,
  );
  if (!(isAdmin || canOpenDoc)) {
    return `${commonPathName}/list`;
  }
  return `${commonPathName}/${document.id}/detail`;
}
